const NAME = "backdrop";

type Config = {
  className?: string;
  clickCallback: null | undefined | (() => void);
};

class Backdrop {
  private elem: null | HTMLElement = null;

  private isAppended = false;

  private config;

  private boundHandleClick: () => void;

  constructor(config: Config) {
    this.config = config;
    this.boundHandleClick = this.handleClick.bind(this);
  }

  static get NAME() {
    return NAME;
  }

  show(): void {
    this.append();
  }

  hide(): void {
    this.dispose();
  }

  dispose(): void {
    if (!this.isAppended) {
      return;
    }
    this.elem!.removeEventListener("click", this.boundHandleClick, true);
    this.elem!.remove();
    this.isAppended = false;
  }

  private append(): void {
    if (this.isAppended) {
      return;
    }

    const elem = this.getElement();
    elem.style.pointerEvents = "auto";
    document.body.append(elem);
    elem.addEventListener("click", this.boundHandleClick, true);

    this.isAppended = true;
  }

  private getElement(): HTMLElement {
    if (!this.elem) {
      const backdrop = document.createElement("div");
      if (this.config.className) {
        backdrop.className = this.config.className;
      }
      this.elem = backdrop;
    }

    return this.elem;
  }

  private handleClick(): void {
    if (this.config.clickCallback) {
      this.config.clickCallback();
    }
  }
}

export default Backdrop;
